import clsx from "clsx"
import { MouseEvent, useContext } from "react"

import { faIcon } from "@utils/faIcon"

import { ExtraTouchArea } from "@particles/index"

import { IconButton } from "@atoms"

import { PopoverContext } from "@molecules/Popover/Popover"

import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"

import styles from "./PopoverHeaderBackButton.module.scss"
import type { PopoverHeaderBackButtonProps } from "./PopoverHeaderBackButton.types"

export default function PopoverHeaderBackButton(props: PopoverHeaderBackButtonProps) {
    const { className, onClick, "aria-label": ariaLabel, isTabbable, icon, backDestination, isPressed } = props
    const { isOpen } = useContext(PopoverContext)
    const { navigate } = useComponentNavigation()

    const onBackClick = (event: MouseEvent<HTMLButtonElement>) => {
        if (backDestination) {
            navigate(backDestination, "left")
        } else if (onClick) {
            onClick(event)
        }
    }

    return (
        <ExtraTouchArea extraTouchArea={8}>
            <IconButton
                size="md"
                variant="ghost"
                className={clsx(styles.base, className)}
                aria-label={ariaLabel || "Back"}
                icon={icon || faIcon({ name: "arrow-left", style: "regular" })}
                onClick={onBackClick}
                isTabbable={isTabbable ?? Boolean(isOpen)}
                isPressed={isPressed}
                noDebounce={true}
            />
        </ExtraTouchArea>
    )
}
